export enum LoginOutcome
{
    Success="Success",
    Failed="Failed",
};